<template><div><h1>升级到 vux@2.x</h1>
<h3>Vue@2.x 主要变更</h3>
<p>参考<a href="https://cn.vuejs.org/v2/guide/migration.html">Vue官方文档</a>进行迁移, 这也是Vux组件的代码更新部分，主要包括：</p>
<ul>
<li><code>:value.sync</code> 已经废弃</li>
<li><code>broadcast</code> 方法已经废弃</li>
<li><code>@click</code> 需要更改为 <code>@click.native</code></li>
<li><code>v-for</code>的<code>(index, item)</code> =&gt; <code>(item, index)</code></li>
</ul>
<h3>vue-router 更新</h3>
<p>配合vue2, <code>vue-router</code>同样需要更新到2.0版本以上</p>
<p>原来的路由配置修改为：</p>
<pre class="hljs"><code>
<span class="hljs-keyword">const</span> routes = [{
  <span class="hljs-attr">path</span>: <span class="hljs-string">'/vux/2.0'</span>,
  <span class="hljs-attr">component</span>: Vux2Demo
}]

<span class="hljs-keyword">const</span> router = <span class="hljs-keyword">new</span> VueRouter({
  routes
})

</code></pre>
<p>原来的路由挂载修改为：</p>
<pre class="hljs"><code><span class="hljs-keyword">new</span> Vue({
  router,
  <span class="hljs-attr">render</span>: <span class="hljs-function"><span class="hljs-params">h</span> =&gt;</span> h(App)
}).$mount(<span class="hljs-string">'#app'</span>)
</code></pre>
<p><code>go</code> 已经不是过去的 <code>go</code>了，要用<code>push</code>方法来跳转</p>
<pre class="hljs"><code><span class="hljs-keyword">this</span>.$router.go(<span class="hljs-string">'/somewhere'</span>)
</code></pre>
<p><code>v-link</code>也废弃了，使用<code>router-link</code>组件来代替</p>
<p>其他请参考官方升级文档: <a href="https://cn.vuejs.org/v2/guide/migration-vue-router.html">https://cn.vuejs.org/v2/guide/migration-vue-router.html</a></p>
<h3>不再生成<code>umd</code>文件</h3>
<p>但是你可以使用<code>npm run build-components</code>来生成，请参考文档首页。</p>
<h3>双向绑定修改为 <code>v-model</code></h3>
<p>所有相关Vux调用的 <code>:value.sync</code>都需要更改成 <code>v-model</code></p>
<pre class="hljs"><code><span class="hljs-comment">// 0.x</span>
&lt;component :value.sync=<span class="hljs-string">"someValue"</span>&gt;<span class="xml"><span class="hljs-tag">&lt;/<span class="hljs-name">component</span>&gt;</span></span>
<span class="hljs-comment">// 2.x</span>
&lt;component v-model=<span class="hljs-string">"someValue"</span>&gt;<span class="xml"><span class="hljs-tag">&lt;/<span class="hljs-name">component</span>&gt;</span></span>
</code></pre>
<h3>使用 vux-loader</h3>
<p>原来你可能在webpack中做了这样的配置以正确编译vux的js源码：</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">test</span>: <span class="hljs-regexp">/vux.src.*?js$/</span>,
  <span class="hljs-attr">loader</span>: <span class="hljs-string">'babel'</span>
}
</code></pre>
<p>或者你也可能使用了低版本<code>vux-loader</code>的<code>getBabelLoader</code>方法。</p>
<p>现在你可以直接删除这一句了，直接使用vux-loader。</p>
<p>在<code>webpack.base.conf.js</code>中这样配置：</p>
<pre class="hljs"><code><span class="hljs-keyword">const</span> vuxLoader = <span class="hljs-built_in">require</span>(<span class="hljs-string">'vux-loader'</span>)
<span class="hljs-built_in">module</span>.exports = vuxLoader.merge(webpackConfig, {
  <span class="hljs-attr">options</span>: {},
  <span class="hljs-attr">plugins</span>: [
    {
      <span class="hljs-attr">name</span>: <span class="hljs-string">'vux-ui'</span>
    }
  ]
})
</code></pre>
<h3>引入方式变更</h3>
<p>原来你可能是单个组件引入，现在在<code>vux-loader</code>的支持下你可以直接这样写：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { Group, Cell } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<h3>组件名字变更</h3>
<p class="tip">
  为什么不参照其他组件库全部加上`X`前缀，主要是因为觉得总要写个`X`相当不顺手。
</p>
<p>因Vue2.0限制组件名不能与原有的html5标签一样，因此部分组件进行了重命名，加上 <code>x-</code>前缀，所有需要加前缀的组件如下：</p>
<ul>
<li><code>Progress</code> =&gt; <code>XProgress</code></li>
<li><code>Switch</code> =&gt; <code>XSwitch</code></li>
<li><code>Dialog</code> =&gt; <code>XDialog</code></li>
<li><code>Address</code> =&gt; <code>XAddress</code></li>
<li><code>Circle</code> =&gt; <code>XCircle</code></li>
<li><code>XButton</code></li>
<li><code>XImg</code></li>
<li><code>XInput</code></li>
<li><code>XTextarea</code></li>
<li><code>XHeader</code></li>
</ul>
<h3>各个组件变更：</h3>
<h4>Swiper 引入路径变化</h4>
<p>目录结构变化，与其他有子组件的统一，导致引入方式变化：</p>
<pre class="hljs"><code><span class="hljs-comment">// 0.x</span>
<span class="hljs-keyword">import</span> Swiper <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/components/swiper'</span>
<span class="hljs-keyword">import</span> SwiperItem <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/components/swiper-item'</span>
<span class="hljs-comment">// 2.0</span>
<span class="hljs-keyword">import</span> Swiper <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/components/swiper/swiper'</span>
<span class="hljs-keyword">import</span> SwiperItem <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/components/swiper/swiper-item'</span>
<span class="hljs-comment">// 或者</span>
<span class="hljs-keyword">import</span> { Swiper, SwiperItem } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux/src/components/swiper'</span> <span class="hljs-comment">// with vux-loader</span>
</code></pre>
<h4>ColorPicker 废弃</h4>
<p class="tip">
  `2.0.0`可用用，但是后面不再维护。
</p>
<p>这个组件可以由<code>cell</code>配合<code>slot</code>扩展出来，而且更灵活。没有做过统计，但是感觉使用人数应该挺少。</p>
<h4>Countdown 废弃</h4>
<p class="tip">
  `2.0.0`可用，但是后面不再维护。
</p>
<p>功能薄弱，比较鸡肋。</p>
<h4>Scroller reset方法更新</h4>
<p>由于 Vue@2.x 的<code>broadcast</code>方法已经废弃，并且之前的设计也并不是很好，uuid的绑定也其实是没必要的。</p>
<ul>
<li>
<p>reset方法变成使用ref的<code>reset()</code>方法</p>
</li>
<li>
<p>pullup reset 变成 ref 的 <code>donePullup()</code>方法</p>
</li>
<li>
<p>pullup disable 变成 ref 的 <code>disablePullup()</code>方法</p>
</li>
<li>
<p>pullup enable 变成 ref 的 <code>enablePullup()</code>方法</p>
</li>
<li>
<p>pulldown reset 变成 ref 的 <code>donePulldown()</code>方法</p>
</li>
<li>
<p>pullup和pulldown的status绑定变成<code>v-model=&quot;status&quot;</code>绑定，示例</p>
<pre class="hljs"><code>status: {
  <span class="hljs-attr">pullupStatus</span>: <span class="hljs-string">'default'</span>,
  <span class="hljs-attr">pulldownStatus</span>: <span class="hljs-string">'default'</span>
}
</code></pre>
</li>
</ul>
<p>详细参照<a href="#" router-link="/zh-CN/components?id=scroller">Scroller文档</a>进行更新</p>
<h4>表单默认required为true</h4>
<p>保持和<code>html</code>规范一致, 影响的组件有 <code>XInput</code> <code>Checklist</code></p>
<h4>Checklist 不显示错误提示</h4>
<p>考虑到错误样式目前并不优雅，而用户有自定义错误样式的需要，因此处理成emit一个错误事件+底部slot， 用户可自行处理。</p>
<h4>XInput 的valid获取</h4>
<p>由于Vue2的$ref不再是响应的，因此不能直接在模板中通过ref调用组件的valid值(会报undefined)，所以需要变成在提交时再进行ref来获取valid值。</p>
<h4>XAddress 默认地址数据更新</h4>
<p>目前引用方式：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XAddress, ChinaAddressData } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>如果你想继续使用旧版本数据</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { XAddress, ChinaAddressV1Data } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
</code></pre>
<p>按照<a href="http://www.stats.gov.cn/tjsj/tjbz/xzqhdm/201608/t20160809_1386477.html">最新统计局数据</a>进行更新，部分区域已经不存在，部分id做了更新。因此请<em>谨慎</em>更新，评估后端数据存储设计和前端交互再进行更新，避免错误更新用户数据或者导致数据丢失。</p>
<p>完整更新如下图:</p>
<p align="center">
  <img src="https://github.com/airyland/china-area-data/raw/master/v2.0.0.changes.png" alt="">
</p>
</div></template><script>
export default {
  head: {"title":"升级到 vux@2.x | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// upgrade-to-vux2-172.vue?ebc37704